import { useEvent } from '../contexts/EventContext';

export default function Logo({ size = 'md', showText = true, className = '' }) {
  const { currentEvent } = useEvent();
  
  const sizes = {
    sm: 'h-12 w-auto',
    md: 'h-16 w-auto',
    lg: 'h-24 w-auto',
    xl: 'h-32 w-auto'
  };

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      <img
        src="/c4ac-logo.png"
        alt="Cruise for a Cause"
        className={`${sizes[size]} object-contain`}
      />
      {showText && (
        <div className="hidden sm:block">
          <span className={`${
            size === 'sm' ? 'text-lg' : 
            size === 'md' ? 'text-xl' : 
            size === 'lg' ? 'text-2xl' : 
            'text-3xl'
          } font-bold text-gray-900`}>
            {currentEvent?.name || 'Car Show Management'}
          </span>
        </div>
      )}
    </div>
  );
}
